import React from 'react';
import processList from 'data/feature/processList';
import Section from 'components/common/Section';
import Process from './Process';
import SectionHeader from './SectionHeader';
import { isIterableArray } from 'helpers/utils';

const Processes = () => (
 <>
  <Section fluid={true}>
   <SectionHeader
    title="El futuro del cuidado veterinario"
    subtitle="Transforma la salud de tu mascota y alcanza su máximo bienestar. En Fortis Control, estamos comprometidos a ser tu aliado estratégico hacia la realización de sus objetivos de salud."
   />
   {isIterableArray(processList) &&
    processList.map((process, index) => <Process key={process.color} isFirst={index === 0} {...process} />)}
  </Section>
 </>
);

export default Processes;
